import React from "react";
import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import {
  CoreUiComponents,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import clsx from "clsx";
import defaultStyles from "./Pill.module.scss";

export enum PillTone {
  neutral = "neutral",
  success = "success",
  error = "error",
  caution = "caution",
  custom = "custom",
  interactive = "interactive",
  info = "info",
}

export enum PillStrength {
  default = "default",
  subtle = "subtle",
  strong = "strong",
}

export interface PillComponentProps extends PlatformComponentProps {
  icon?: React.ReactNode;
  tone?: PillTone;
  size?: "small" | "normal" | "large" | "custom";
  strength?: PillStrength;
}

export const Pill = ({
  children,
  className,
  icon,
  tone = PillTone.neutral,
  size = "normal",
  strength = PillStrength.default,
}: PillComponentProps) => {
  const styles = useUiStyles(CoreUiComponents.Pill, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreUiComponents.Pill, [
    tone,
    `size-${size}`,
    strength,
  ]);

  return (
    <span className={clsx(block, className)}>
      {icon != null ? <span className={cn("icon")}>{icon}</span> : null}
      {children != null ? <span className={cn("text")}>{children}</span> : null}
    </span>
  );
};
